/**
 * SessionStorage / LocalStorage キー定数
 *
 * 複数のコンポーネントで共有されるストレージキーを一元管理
 * - 重複を防ぎ、メンテナンス性を向上
 */
export const STORAGE_KEYS = {
  /**
   * 認証前に保存するフォームデータ
   * OAuth リダイレクト後にデータを復元するために使用
   */
  PENDING_FORM_DATA: 'pending_form_data',

  /**
   * OAuth 認証処理中フラグ
   * 認証リダイレクト前に設定し、コールバック時に確認
   */
  OAUTH_PENDING: 'oauth_pending',

  /**
   * 認証状態の永続化キー
   * Zustand persist middleware で使用
   */
  AUTH_STORAGE: 'auth-storage',
} as const;

/**
 * ストレージキーの型
 */
export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
